/* eslint-disable react/prop-types */

import React from 'react';
import {loadable, isSearchPage} from 'router/routes';
import {fetchCleanedData} from 'router/router-actions';
import EventsAPI from 'api/events';
import merge from 'lodash/merge';
import includes from 'lodash/includes';
import Config from 'config';

const SearchMobile = loadable(() => import('search/SearchMobile'));
const SearchDesktop = loadable(() => import('search/SearchDesktop'));
const MidFunnelAirport = loadable(() =>
    import('mid-funnel/airport/MidFunnelAirport')
);
const NotFound = loadable(() => import('router/NotFound'));

const SearchPage = ({configData: {isMobile}}) =>
    isMobile ? <SearchMobile /> : <SearchDesktop />;

function CatchAll({configData, isMonthly, destination, match}) {
    const {
        params: {page, section},
    } = match;

    if (
        (!section && includes(configData.citySlugs, page)) ||
        isSearchPage(page, section)
    ) {
        if (destination && destination.airport && !isMonthly) {
            return <MidFunnelAirport />;
        }

        return <SearchPage configData={configData} />;
    }

    return <NotFound />;
}

CatchAll.getInitialState = async ({state: initialState, route}) => {
    const state = await fetchCleanedData({
        state: initialState,
        route,
    });

    const {
        destination: {
            data: {id: destinationId, has_upcoming_events: hasEvents},
        },
        searchRequest: {pageType},
    } = state;

    if (pageType !== 'event' && hasEvents && !Config.isMobile) {
        const events = await EventsAPI.get({destinationId}).then(
            res => res.data.data.results
        );

        return merge({}, state, {
            destination: {
                data: {
                    events,
                },
            },
        });
    }

    return state;
};

export default CatchAll;
